/** Split rounded minutes into whole hours and minutes without floor/ceil. */
export function splitAirtimeMinutes(minutes: number): {
  h: number
  m: number
} {
  const totalMin = Math.round(minutes)
  return {
    h: (totalMin - (totalMin % 60)) / 60,
    m: totalMin % 60,
  }
}
